const getReportCardEnv = () => {
  const productionUrl = process.env.REACT_APP_PRODUCTION_URL || ''
  if (productionUrl.includes('ams-stg')) {
    return 'stg'
  }
  return 'prod'
}

export const hasGeneratedReportCard = (candidateDetails?: { section_level_details?: unknown; score_card_url?: string | null }) =>
  Boolean(candidateDetails?.section_level_details || candidateDetails?.score_card_url)

export const getServerReportCardDownloadUrl = (candidateId: string, testType: string) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL
  const env = getReportCardEnv()
  const normalizedType = (testType || 'tq').toLowerCase()
  if (backendUrl) {
    return `${backendUrl}/generate/reportcard-link/${env}/${normalizedType}/${encodeURIComponent(candidateId)}?mode=download`
  }
  const baseUrl = process.env.REACT_APP_PRODUCTION_URL || window.location.origin
  return `${baseUrl}/.netlify/functions/generate-reportcard-pdf?env=${env}&testType=${normalizedType}&candidateId=${encodeURIComponent(candidateId)}`
}

export const getMobileReportCardDownloadUrl = (candidateId: string, testType: string) => {
  const baseUrl = process.env.REACT_APP_PRODUCTION_URL || window.location.origin
  const params = new URLSearchParams({
    testType: (testType || 'tq').toLowerCase(),
    candidateId,
  })

  return `${baseUrl}/download/scorecard-pdf?${params.toString()}`
}
